import moment from "moment";
import { CompanionAPI } from "../api";
import { Customer } from "./Customer.class";
import Helper from "../plugins/Helper/Helper";
export class Companion {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    this.fullName = `${this.title ? this.title : ''} ${this.firstName || ''} ${this.lastName || ''}`
    this.fullNameNoTitle = `${this.firstName || ''} ${this.lastName || ''}`

    if (this.customerCompanions && this.customerCompanions.length) {
      for (let customerCompanion of this.customerCompanions) {
        customerCompanion.customer = new Customer(customerCompanion.customer)
      }
    }
    this.joinTels = Helper.telToString(this.interTels, this.tels) || ''
    this.genderText = this.gender == "m" ? "ชาย" : this.gender == "f" ? "หญิง" : "-"
    this.labelSearch = `${this.fullNameNoTitle} ${this.joinTels} ${this.citizenId ? this.citizenId : ''}`
  }

  static async createCompanion(payload) {
    const { data } = await CompanionAPI.createCompanion(payload);
    return new Companion(data.result);
  }
  static async updateCompanion(payload) {
    const { data } = await CompanionAPI.updateCompanion(payload);
    return new Companion(data.result);
  }
  static async getCompanions(payload) {
    const { data } = await CompanionAPI.getCompanions(payload);
    return data.result.map(item => new Companion(item));
  }
  static async getCompanion(payload) {
    const { data } = await CompanionAPI.getCompanion(payload);
    return new Companion(data.result);
  }
  static async getCompanionByKeyword(payload) {
    const { data } = await CompanionAPI.getCompanionByKeyword(payload);
    return data.result.map(item => new Companion(item));
  }
  static async getCompanionsByCustomer(payload) {
    const { data } = await CompanionAPI.getCompanionsByCustomer(payload);
    return data.result.map(item => new Companion(item));
  }
  static async getCompanionsByProject(projectId, limit, page, order) {
    const { data } = await CompanionAPI.getCompanionsByProject(
      projectId,
      limit,
      page,
      order
    );
    return data.result.map(item => new Companion(item));
  }
}
